import { createActions } from 'redux-actions';

const PREFIX = '@@nosturi/orm';

const BASIC_ACTIONS = {
  RESET_ALL: undefined,
  CREATE: undefined,
  DESTROY: undefined,
  UPSERT: undefined,
  UPDATE: (primaryKey, props) => ({ primaryKey, props }),
};

const actions = createActions(
  {
    RESET: undefined,
    GENDER: {
      ...BASIC_ACTIONS,
    },
    LIFT: {
      ...BASIC_ACTIONS,
    },
    BODYWEIGHT_CATEGORY: {
      ...BASIC_ACTIONS,
    },
    AGE_GROUP: {
      ...BASIC_ACTIONS,
    },
    EVENT: {
      RESET_ALL: undefined,
    },
    CONTEST: {
      ...BASIC_ACTIONS,
    },
    TEAM: {
      ...BASIC_ACTIONS,
    },
    ENTRY: {
      ...BASIC_ACTIONS,
    },
    LOT: {
      RESET_ALL: undefined,
    },
    GROUP: {
      ...BASIC_ACTIONS,
    },
    SESSION: {
      ...BASIC_ACTIONS,
    },
    WEIGH_IN_DATUM: {
      ...BASIC_ACTIONS,
    },
    WEIGH_IN_DECLARATION: {
      ...BASIC_ACTIONS,
    },
    PROTOCOL: {
      ...BASIC_ACTIONS,
    },
    ATHLETE: {
      ...BASIC_ACTIONS,
      /*
      DECLARE_WEIGHT: (primaryKey, liftPrimaryKey, attemptNumber, weight) => ({
        primaryKey,
        liftPrimaryKey,
        attemptNumber,
        weight,
      }),
      SET_DECISION: (primaryKey, liftPrimaryKey, attemptNumber, decision) => ({
        primaryKey,
        liftPrimaryKey,
        attemptNumber,
        decision,
      }),
      */
    },
    DECLARATION: {
      ...BASIC_ACTIONS,
    },
    ATTEMPT: {
      ...BASIC_ACTIONS,
    },
    DECISION: {
      ...BASIC_ACTIONS,
    },
    RESULT: {
      ...BASIC_ACTIONS,
    },
  },
  {
    prefix: PREFIX,
  },
);

export { PREFIX, actions };
export default actions;



// WEBPACK FOOTER //
// ./src/orm/actions.js